import FastOrder from './FastOrder';
export default FastOrder;